import { compose } from 'redux';
import { connect } from 'react-redux';
import {
    GetAllSeminarRequested,
    ClearSeminarData,
    GetDetailSeminarIgnoreCompanyIdRequested,
    ClearDetailSeminarData,
    UpdateSeminarIgnoreCompanyIdRequested,
    ClearSeminarUpdateData,
} from '../../../actions/SeminarManagement';
import ListAllSeminar from '../../../pages/Admin/SeminarManagement/ListAllSeminar';
import withAuth from '../../../common/WithAuth';
import SeminarManagementSelector from '../../../selectors/SeminarManagement';
import { callApiGetInformationRoom } from '../../../actions/RegistrationOrganizer';

const mapStateToProps = (state) => ({
    isLoading: state.seminars.listSeminars.isFetching,
    seminars: state.seminars.listSeminars.data.results,
    pagination: SeminarManagementSelector.createPaginationListAllSeminarSelector()(state),
    eventInfo: state.eventManagement.infoEvent.data,
    room: state.registrationOrganizer.registrationOrganizer.room,
    detailSeminar: state.seminars.detail.data,
    updateSuccess: state.seminars.update.success,
    updateErrors: state.seminars.update.errors.errors,
    updateSeminarResponse: state.seminars.update.data,
    detailSeminarErrors: state.seminars.detail.errors?.errors,
});

const mapDispatchToProps = (dispatch) => ({
    fetchAllSeminars: (params = {}) => {
        dispatch(GetAllSeminarRequested(params));
    },
    resetSeminarsData: () => {
        dispatch(ClearSeminarData());
    },
    getInformationRoom: (params) => {
        dispatch(callApiGetInformationRoom(params));
    },
    getDetailSeminar: (params) => {
        dispatch(GetDetailSeminarIgnoreCompanyIdRequested(params));
    },
    updateSeminar: (params) => {
        dispatch(UpdateSeminarIgnoreCompanyIdRequested(params));
    },
    resetDetailSeminar: () => {
        dispatch(ClearDetailSeminarData());
    },
    resetUpdateSeminarData: () => {
        dispatch(ClearSeminarUpdateData());
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListAllSeminar);
